import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { SharedModule } from '../../core/shared.module';
import { SatelliteLockRoutingModule } from './satellite-lock-routing.module';

@NgModule({
  imports: [
    SharedModule.forRoot(),
    SatelliteLockRoutingModule
  ],
  declarations: [],
  entryComponents: [],
  exports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SatelliteLockModule { }

